import searchSlugsByCollection from '../api/graphql/queries/searchSlugsByCollection';

const isValidSlugName = async (value, collection) => {
  const getEventsSlugQueryResult = await searchSlugsByCollection(value, collection, true);
  return getEventsSlugQueryResult?.slugNames?.length === 0;
};

export default isValidSlugName;
